import { format, formatDistance, parseISO } from 'date-fns';
const toDate = (value) => {
    if (!value) return null;

    // already a Date
    if (value instanceof Date) return value;

    // timestamp in ms (number or numeric string)
    if (!isNaN(value)) return new Date(Number(value));

    // fallback: try ISO string
    return new Date(value);
};

export const formatDateTime2 = (dateValue) => {
    try {
        const date = toDate(dateValue);
        if (!date || isNaN(date.getTime())) return 'N/A';
        return format(date, 'PPpp');
    } catch {
        return 'N/A';
    }
};

export const formatRelativeTime2 = (dateValue) => {
    try {
        const date = toDate(dateValue);
        if (!date || isNaN(date.getTime())) return 'N/A';
        return formatDistance(date, new Date(), { addSuffix: true });
    } catch {
        return 'N/A';
    }
};
export const formatDateTime = (dateString) => {
    if (!dateString) return 'N/A';
    try {
        return format(parseISO(dateString), 'PPpp');
    } catch (error) {
        return dateString;
    }
};

export const formatRelativeTime = (dateString) => {
    if (!dateString) return 'N/A';
    try {
        return formatDistance(parseISO(dateString), new Date(), { addSuffix: true });
    } catch (error) {
        return dateString;
    }
};

export const copyToClipboard = async (text) => {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch (error) {
        console.error('Failed to copy:', error);
        return false;
    }
};

export const downloadFile = (url, filename) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
};

export const getInitials = (name) => {
    if (!name) return '?';
    return name
        .split(' ')
        .map(word => word[0])
        .join('')
        .toUpperCase()
        .slice(0, 2);
};